import autoTable from "jspdf-autotable";
import { drawGrandTotal } from "./caSdrawGrandTotalpdf";
import { PDF_TABLE_STYLE, PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

  const columnStyles = {
    // 0: { cellWidth: 40, halign: "left" },
    0: { cellWidth: 30, halign: "left" },
    1: { cellWidth: 35, halign: "right" },
    2: { cellWidth: 35, halign: "right" },
    3: { cellWidth: 35, halign: "right" },
    4: { cellWidth: 35, halign: "right" },
    5: { cellWidth: 35, halign: "right" },


  };



  function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  // ================= HEADER =================
  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GROUP);
  doc.rect(14, startY - 10, 270, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_GROUP);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_GROUP);
  doc.text(`${shop}`, 20, startY - 5);

  // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
    ...PDF_TABLE_STYLE,
    head: [[
      // "Depot",
      "SHOP",
      "Actual O/C Labour",
      "Distributed O/C Labour",
      "U/O Charge O/C Labour",
      "Actual O/C Store",
      "Distributed O/C Store",
      "U/O Charge O/C Store",

    ]],

    body: rows.map((r) => [

      r.SHOPCODE,
      format(r["ACTUAL ON COST LABOUR"]),
      format(r["DISTRIBUTED ON COST LABOUR"]),
      format((Number(r["ACTUAL ON COST LABOUR"]) - Number(r["DISTRIBUTED ON COST LABOUR"]))),
      format(r["ACTUAL ON COST STORE"]),
      format(r["DISTRIBUTED ON COST STORE"]),
      format((Number(r["ACTUAL ON COST STORE"]) - Number(r["DISTRIBUTED ON COST STORE"]))),




    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 270, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`${String(shop).trim()}  Total`, 16, y + 5);


  // Credit Total
  doc.text(format(total.actual_L.toFixed(2)), 82, y + 5, {
    align: "right",
  });


  // Debit Total
  doc.text(format(total.dist_L.toFixed(2)), 112, y + 5, {
    align: "right",
  });



  doc.text(format(total.ou_LL.toFixed(2)), 147, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.actual_S.toFixed(2)), 177, y + 5, {
    align: "right",
  });


  // Debit Total
  doc.text(format(total.dist_S.toFixed(2)), 220, y + 5, {
    align: "right",
  });



  doc.text(format(total.ou_SS.toFixed(2)), 275, y + 5, {
    align: "right",
  });

  // Reset text color
  doc.setTextColor(0);

  // Reserve space after Depot Total
  doc.lastAutoTable.finalY = y + 5;
  //                 rectangle height ^   ^ extra space
}



